module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "100"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.notifyChangesMenuClicked
    }
  }, [_c('v-list-item-title', [_vm._v("Notify Office of Changes")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [(_vm.checklistKey) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('ChecklistDetails', {
    attrs: {
      "pageSettings": _vm.pageSettings,
      "checklistKey": _vm.checklistKey,
      "mode": "Client"
    },
    on: {
      "change": _vm.documentChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-text light-text"
  }, [_vm._v("Click on a document to upload files or see more information")])], 1) : [_c('NoRecordsPlaceholder', {
    attrs: {
      "message": "No checklist specified"
    }
  })]], 2), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('AdvancedDialog', {
    attrs: {
      "record": _vm.addDocumentDialog.record,
      "settings": _vm.addDocumentDialog.settings,
      "fields": _vm.addDocumentDialog.fields
    },
    on: {
      "save": _vm.saveDocumentForCategory
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-031ac46a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/ClientChecklist.vue
// module id = 2428
// module chunks = 1